<template>
  <div
    class="h-full w-full bg-[#0d2149] text-white flex flex-col justify-between p-8 lg:p-14 select-none relative overflow-hidden box-border">
    <!-- Top Left Brand Header -->
    <div class="flex items-center gap-3.5 z-10 shrink-0">
      <!-- <div
        class="w-10 h-10 min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] rounded-xl bg-white text-[#0d2149] flex items-center justify-center font-black text-xl shadow-md shrink-0">
        CW
      </div> -->
      <div class="w-full d-flex align-center mb-6 flex-shrink-0 select-none">
        <div class="w-14 h-14 rounded-full border border-white  p-2 mr-3 shrink-0">
          <img src="@/assets/img/CW_DEFAULT_WHITE.png" alt="Cuality Works"
            class="w-full h-full object-contain block pointer-events-none" />
        </div>
        <span class="text-xl font-bold tracking-tight text-white whitespace-nowrap">CualityWork</span>
      </div>
    </div>

    <!-- Center Pitch & Step Checklist -->
    <div class="max-w-lg my-auto py-8 z-10 space-y-7">
      <div>
        <h1 class="text-3xl lg:text-4xl font-black text-white leading-tight mb-3 tracking-tight">
          Set up your team's workspace in minutes
        </h1>
        <p class="text-blue-100/80 text-sm lg:text-base leading-relaxed mb-0">
          For managers and business owners who need to see attendance, field visits and customer work in one place.
        </p>
      </div>

      <!-- Step Checklist matching reference -->
      <div class="space-y-5">
        <!-- Step 1 -->
        <div class="flex items-start gap-4">
          <div
            class="w-7 h-7 min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] rounded-full bg-blue-500 text-white font-bold text-xs flex items-center justify-center shrink-0 shadow-sm mt-0.5">
            1
          </div>
          <div class="min-w-0 flex-1">
            <h3 class="text-sm lg:text-base font-bold text-white mb-0.5">Create your company account</h3>
            <p class="text-xs text-blue-200/70 mb-0">Just your email and company details.</p>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="flex items-start gap-4">
          <div
            class="w-7 h-7 min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] rounded-full bg-blue-600/80 text-white font-bold text-xs flex items-center justify-center shrink-0 shadow-sm mt-0.5">
            2
          </div>
          <div class="min-w-0 flex-1">
            <h3 class="text-sm lg:text-base font-bold text-white mb-0.5">Add your employees</h3>
            <p class="text-xs text-blue-200/70 mb-0">Add them one by one or upload a list.</p>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="flex items-start gap-4">
          <div
            class="w-7 h-7 min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] rounded-full bg-blue-700/80 text-white font-bold text-xs flex items-center justify-center shrink-0 shadow-sm mt-0.5">
            3
          </div>
          <div class="min-w-0 flex-1">
            <h3 class="text-sm lg:text-base font-bold text-white mb-0.5">Start tracking</h3>
            <p class="text-xs text-blue-200/70 mb-0">See who has clocked in, where they are and what they have done.</p>
          </div>
        </div>
      </div>

      <!-- Capability Feature Chips -->
      <div class="flex flex-wrap gap-2 pt-1 items-center">
        <span v-for="chip in featureChips" :key="chip"
          class="inline-flex items-center w-auto px-3 py-1 rounded-full bg-white/10 hover:bg-white/15 text-blue-100 text-xs font-medium border border-white/10 transition-colors shrink-0">
          {{ chip }}
        </span>
      </div>
    </div>

    <!-- Bottom Employee App Banner Link -->
    <div class="text-xs text-white/90 z-10 pt-4 border-t border-white/20 flex items-center justify-between">
      <span>
        Are you an employee? Use the CualityWork Employee app to clock in.
      </span>
      <a
        href="https://play.google.com/store/apps/details?id=com.workforce.cualitywork&hl=en_IN"
        target="_blank"
        rel="noopener noreferrer"
        class="!text-white font-bold underline hover:opacity-80 ml-1 shrink-0"
      >
        Get the app
      </a>
    </div>

    <!-- Subtle background radial glow decorative decoration -->
    <div class="absolute -right-24 -bottom-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl pointer-events-none"></div>
  </div>
</template>

<script>
export default {
  name: 'LoginCarousel',
  data() {
    return {
      featureChips: [
        'Attendance',
        'Live location',
        'Leads',
        'Customers',
        'Campaigns',
        'AMC and spare parts'
      ]
    }
  }
}
</script>
